import React, { useEffect, useState } from "react";
import { Endpoint } from "../../api/base";
import InvoicePage from "../../components/invoice/InvoicePage";
import Accounting from "../../components/Accounting/index";
import {
  getAccountingJson,
  getClient,
} from "../../components/shared/helpers/helper";
import { IconButton, makeStyles } from "@material-ui/core";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { tokens } from "../../theme/tokens";

const useStyles = makeStyles((theme) => ({
  stack: {
    border: `1px solid ${tokens.color.border.default}`,
  },
  icon: {
    // color: tokens.color.surface.subtle,
    display: "flex",
    justifyContent: "center",
    "&:hover": {
      color: tokens.color.text.primary,
    },
    cursor: "pointer",
  },
}));

function Invoice({ caseData }) {
  const classes = useStyles();
  const [generatePDF, setGeneratePDF] = useState(false);
  const [invoices, setInvoices] = useState([]);
  const [invoiceIndex, setInvoiceIndex] = useState(null);
  const [clientRates, setClientRates] = useState(null);
  useEffect(() => {
    Endpoint.getClients()
      .then((response) => {
        var clientDetails = getClient(
          response.data,
          caseData.case_detail.client_id,
        );

        var client_rates = {
          hourly_rate: parseFloat(clientDetails.hourly_rate).toFixed(2),
          database_search_rate: parseFloat(
            clientDetails.database_search_rate,
          ).toFixed(2),
          local_investigator_rate: parseFloat(
            clientDetails.local_investigator_rate,
          ).toFixed(2),
          local_investigator_mileage_rate: parseFloat(
            clientDetails.local_investigator_mileage_rate,
          ).toFixed(2),
        };

        setClientRates(client_rates);
        // get invoices

        Endpoint.getInvoices({ file_no: caseData.case_detail.file_no })
          .then((res) => {
            if (res.data.length) {
              //invoice exists
              setInvoices(res.data);
            } else {
              // invoice doesnt exist

              setInvoices([
                getAccountingJson(
                  caseData.case_detail.file_no,
                  caseData.case_detail.case_details.case_information,
                  caseData.case_detail.case_details.client_information,
                  false,
                  client_rates,
                ),
              ]);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => console.log(err));

    // setInvoices()
  }, []);

  return (
    <>
      {generatePDF ? (
        <div>
          <div style={{ width: "700px", margin: "20px auto 0px" }}>
            <IconButton
              className={classes.stack}
              onClick={() => {
                setGeneratePDF(false);
              }}
            >
              <ArrowBackIosIcon className={classes.icon} />
            </IconButton>
          </div>

          <div style={{ width: "700px", margin: "30px auto 50px" }}>
            <InvoicePage
              caseData={caseData}
              invoices={invoices[invoiceIndex]}
              invoiceIndex={invoiceIndex}
            />
          </div>
        </div>
      ) : (
        <>
          {invoices.length && (
            <Accounting
              invoices={invoices}
              caseData={caseData}
              setInvoices={setInvoices}
              setGeneratePDF={setGeneratePDF}
              setInvoiceIndex={setInvoiceIndex}
              clientRates={clientRates}
            />
          )}
        </>
      )}
    </>
  );
}

export default Invoice;
